import React, { Fragment, useContext, useEffect } from "react";
import AppContext from "../../Store/AppContext";
import WhatsAppChat from "../../Components/Chat/WhatsAppChat";
import ModalComponente from "../../Components/Chat/ModalComponente/ModalComponente";
import "./Index.css";

const tituloTela = "Home";

const Index = () => {
  const { setTituloTela } = useContext(AppContext);

  useEffect(() => {
    async function carregarDependencias() {
      setTituloTela(tituloTela);
    }
    carregarDependencias();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Fragment>

    <ModalComponente
      buttonToShow={<span className={`badge badge-danger pt-2`}>
        Não Aprovado
      </span>}
    >

      <WhatsAppChat DddCelular={12} NumCelular={981343333}></WhatsAppChat>

    </ModalComponente>


  </Fragment>;
};

export default Index;
